import React, { useState } from "react";
import { ModalMoKhoa } from "./ModalMoKhoa";

export const BtnMoKhoa = ({ item, onReload }) => {
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const handleChanged = () => {
		setShow(false);
		if (onReload) onReload();
	};
	const type = item.Status !== 2 ? 'khoa' : 'mokhoa';
	return (
		<>
			<a type="button" className="popover-basic" onClick={handleShow} title={item.Status !== 2 ? 'Khóa phiếu' : 'Mở khóa phiếu'}>
				<i className={`mdi ${item.Status !== 2 ? 'mdi-lock' : 'mdi-lock-open-variant'} fa-xl`}></i>
			</a>
			{show && (
				<ModalMoKhoa
					show={show}
					onHide={handleClose}
					item={item}
					onChanged={handleChanged}
					type={type}
				/>
			)}
		</>
	);
};
